<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/channelnotesend/select"
      :model="formModel"
      @openAddDialog="changeNote"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      addShowPower="/channelnotesend/sendsms"
    >
      <el-form-item label="推送范围">
        <el-select v-model="formModel.pushRange">
          <el-option
            v-for="item in pushRanges"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="短信内容">
        <el-input
          v-model="formModel.smsContent"
          maxlength="20"
          placeholder="请输入短信内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话号码">
        <el-input
          v-model="formModel.phone"
          maxlength="20"
          placeholder="请输入电话号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="发送时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="短信类型">
        <el-select v-model="formModel.payType">
          <el-option
            v-for="item in payTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <!--<el-table-column prop="tatName" label="机构简称"></el-table-column>-->
      <el-table-column
        prop="smsContent"
        show-overflow-tooltip
        min-width="160"
        label="短信内容"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        show-overflow-tooltip
        min-width="160"
        label="发布时间"
      ></el-table-column>
      <!--<el-table-column prop="phone" show-overflow-tooltip label="电话号码"></el-table-column>-->
      <el-table-column
        prop="pushRange"
        label="推送范围"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p v-if="scope.row.pushRange == 1">普通短信</p>
          <p v-else-if="scope.row.pushRange == 2">按范围</p>
          <p v-else-if="scope.row.pushRange == 3">按等级</p>
          <p v-else-if="scope.row.pushRange == 4">按系统</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="短信类型"
        min-width="160"
        :formatter="typeStatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="smsCount"
        label="短信发送数量"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="100"
        v-if="hasPerm('/channelnotesend/list')"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="pushInfo(scope.row.id, scope.row.pushRange)"
            >推送列表</el-button
          >
          <!--<el-button  type="text" @click="deleteInfo(scope.row.id)" class="button-color">删除</el-button>-->
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :labelWidth="dialogType != 1 && isShow ? '180px' : '150px'"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      class="over"
      @success="dialogSuccess"
      @close="dialogClose"
      @opend="dialogOpen"
    >
      <div v-if="dialogType == 1">
        <!--<el-form-item label="消息标题" prop="">-->
        <!--<el-input v-model="dialogModel.smsContent" placeholder="请输入消息标题"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="推送范围" prop="pushRange">
          <el-radio
            v-model="dialogModel.pushRange"
            label="1"
            class="commonMargin"
            >普通短信</el-radio
          >
          <el-radio
            v-model="dialogModel.pushRange"
            label="2"
            class="commonMargin"
            >按范围</el-radio
          >
          <el-radio
            v-model="dialogModel.pushRange"
            label="3"
            class="commonMargin"
            >按等级</el-radio
          >
          <el-radio
            v-model="dialogModel.pushRange"
            label="4"
            class="commonMargin"
            >按用户系统</el-radio
          >
        </el-form-item>
        <el-form-item label="发送目标" prop="tarUser" ref="tarUser">
          <el-input
            v-model="dialogModel.tarUser"
            show-word-limit
            placeholder="请输入电话号码"
            maxlength="11"
            v-if="dialogModel.pushRange == 1"
          ></el-input>
          <el-input
            type="textarea"
            resize="none"
            rows="5"
            v-model="dialogModel.tarUser"
            placeholder="多个电话请用“，”分割"
            v-else-if="dialogModel.pushRange == 2"
          ></el-input>
          <el-select
            v-model="dialogModel.tarUser"
            v-else-if="dialogModel.pushRange == 3"
          >
            <el-option
              v-for="item in levelList"
              :key="item.id"
              :label="item.levelName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="dialogModel.tarUser"
            v-else-if="dialogModel.pushRange == 4"
          >
            <el-option
              v-for="item in systemList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息内容" prop="smsContent">
          <el-input
            type="textarea"
            maxlength="200"
            show-word-limit
            resize="none"
            rows="5"
            v-model="dialogModel.smsContent"
            placeholder="请输入消息标题"
          ></el-input>
        </el-form-item>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ElFormItem from "element-ui/packages/form/src/form-item";
import FormDialog from "../../dialog/FormDialog";
import TimeRange from "service/constant/TimeRange";
import Regs from "common/conf/Regs";

import OrganService from "service/OrganService";
import APPService from "service/APPService";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "channelnotesend",
  data() {
    return {
      whole: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      formModel: {
        tatSimpleId: "",
        smsContent: "",
        time: TimeRange.dayRange,
        pushRange: "",
        phone: "",
        payType: "",
      },
      isShow: true,
      tatSimpleNames: [],
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      topTatSimpleNames: [],
      tableData: [],
      submitService: APPService.sendList,
      page: {},
      formDialogTitle: "",
      dialogModel: {
        pushRange: "1",
        tarUser: "",
        smsContent: "",

        upLevelNoticeInfo: "",
      },
      dialogRules: {
        pushRange: [
          {
            required: true,
            message: "请选择推送范围",
          },
        ],
        tarUser: [
          {
            required: true,
            // message: '请选择发送目标'
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("发送目标不能为空"));
              }
              if (this.dialogModel.pushRange == 1) {
                if (!Regs.phone.test(value)) {
                  return callback(new Error("请输入正确的11位手机号码"));
                } else {
                  return callback();
                }
              }
              return callback();
            },
          },
        ],
        smsContent: [
          {
            required: true,
            message: "请输入消息内容",
          },
        ],
      },
      noteId: "",
      systemList: [
        {
          id: "0",
          label: "IOS",
        },
        {
          id: "1",
          label: "Android",
        },
      ],
      levelList: [],
      pushRanges: [
        {
          id: "",
          label: "全部",
        },
        {
          id: "1",
          label: "普通短信",
        },
        {
          id: "2",
          label: "按范围",
        },
        {
          id: "3",
          label: "按等级",
        },
        {
          id: "4",
          label: "按系统",
        },
      ],
      isPage: false,
      dialogType: 1,
      payTypes: [],
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    ElFormItem,
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  computed: {
    dialogData() {
      const sendsmsParams = {
        userId: this.userId,
        pushRange: this.dialogModel.pushRange,
        tarUser: this.dialogModel.tarUser,
        smsContent: this.dialogModel.smsContent,
        type: "5",
      };
      return sendsmsParams;
    },
    dialogService() {
      return APPService.sendsms;
    },
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {
        smsContent: this.formModel.smsContent.trim(),
        type: this.formModel.payType,
        pushRange: this.formModel.pushRange,
        phone: this.formModel.phone,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        createUser: this.userId,
      };

      if (this.formModel.time.length) {
        this.params.startDate = this.formModel.time[0];
        this.params.endDate = this.formModel.time[1];
      }

      return this.params;
    },
    ...mapGetters(["userId"]),
  },
  watch: {
    "dialogModel.pushRange"(val) {
      if (this.dialogType == 1) {
        this.dialogModel.tarUser = "";
        this.$refs.tarUser.clearValidate();
      }
    },
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
    this.getSimpleNames();
    this.getTypeNames("短信类型", (res) => {
      this.payTypes = [...this.whole, ...res];
    });
  },
  methods: {
    getInfo() {
      const params = {
        userId: this.userId,
      };

      this.doLoad(
        OrganService.detail,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogModel = result;
          });
        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        APPService.sendList,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.total = result.total;
            this.page.pageSize = result.size;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getMemLevel() {
      this.doLoad(
        OrganService.memberupgradeList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.levelList = res.contents.rows;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    getSimpleNames() {
      this.doLoad(
        OrganService.simpleNames,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.tatSimpleNames = res.contents;
            this.topTatSimpleNames = [...this.all, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    changeNote(id) {
      this.formDialogTitle = "新建消息";
      this.dialogType = 1;
      // this.noteId = id;
      this.$refs.formDialog.open();
    },
    dialogSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.showSuccess(result.optMsg);
        this.$refs.formDialog.closeDialog();
        if (this.dialogType == 1) {
          this.getList();
        }
      });
    },
    dialogClose() {
      this.dialogModel = {
        pushRange: "1",
        tarUser: "",
        smsContent: "",
      };
    },
    dialogOpen() {
      this.getMemLevel();
      if (this.dialogType != 1) {
        this.getInfo();
      }
    },
    pushInfo(id, pushRange) {
      this.$router.push({
        name: "pushinfo",
        params: {
          id: id,
          pushRange: pushRange,
        },
      });
    },
    doDelete(id) {
      const deleteParams = {
        id: id,
      };

      this.doLoad(
        APPService.deleteSms,
        deleteParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            console.log("result", result);
            if (result.optStatus == "0000") {
              this.showSuccess(result.optMsg);
              this.getList();
            } else {
              this.showError(result.optMsg);
            }
          });
        },
        "操作失败"
      );
    },
    deleteInfo(id) {
      this.showConfirm("确定删除该会员？")
        .then(() => {
          this.doDelete(id);
        })
        .catch(() => {});
    },
    down() {
      this.formDialogTitle = "设置";
      this.dialogType = 2;
      this.$refs.formDialog.open();
    },
    // 类型转换
    // typeStatus: function (row, column) {
    //   switch (row.type) {
    //     case "1":
    //       return "计划消息";
    //       break;
    //     case "2":
    //       return "卡券消息";
    //       break;
    //     case "3":
    //       return "短信验证码";
    //       break;
    //     case "4":
    //       return "机构预警通知";
    //       break;
    //     case "5":
    //       return "用户通知";
    //       break;
    //     case "6":
    //       return "账单日提醒";
    //       break;
    //     default:
    //       return "--";
    //   }
    // },
    typeStatus(row, column, cellValue, index) {
      let value = "--";
      this.payTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
.gutter-bottom {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/SystemManage/ChannelNoteSend.vue